module.exports = __webpack_public_path__ + "static/media/country_tj.5b4bf1f9.webp";